import React from 'react'
import styled from 'styled-components'
import Button from 'components/Button'

const SelectAllFlex = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  flex-wrap: wrap;
`

const SelectionDisplay = ({
  selectedCandidate,
  candidateDeatils,
  isAllSelected,
  handleSelectAllClick,
  handleClearAllClick,
}) => {
  const totalCount = candidateDeatils?.notDisabledCount || candidateDeatils?.count || 0
  const pageCount = selectedCandidate?.length || 0

  return (
    <SelectAllFlex>
      <div style={{ fontSize: '13px', padding: '0px 20px' }}>
        {`Selected `}
        <span style={{ fontWeight: 800 }}>
          {isAllSelected
            ? `${totalCount} ${totalCount > 1 ? 'candidates' : 'candidate'}`
            : `${pageCount} ${pageCount > 1 ? 'candidates' : 'candidate'}`}
        </span>
        {isAllSelected ? ` from all pages` : ` from this page.`}
      </div>
      <Button.Primary
        onClick={() => (isAllSelected ? handleClearAllClick() : handleSelectAllClick())}
        text={
          isAllSelected ? (
            'Clear Selection'
          ) : (
            <>
              {`Select all `}
              <span style={{ fontWeight: 800 }}>
                {`${totalCount} ${totalCount > 1 ? 'candidates' : 'candidate'}`}
              </span>
              {` from all pages.`}
            </>
          )
        }
        fontsize={'0.8rem'}
      />
    </SelectAllFlex>
  )
}

export default SelectionDisplay
